
<div>
  <RouterView v-if="allowed" />
</div>
